<template>
  <a-layout class="nhf-app">
    <a-alert style="
        position: fixed;
        width: 500px;
        min-height: 100px;
        top: 10%;
        left: 50%;
        margin-left: -250px;
        z-index: 100000;
      " v-if="ebsIsFalse" :message="ebsMessage" :type="ebsType" show-icon>
      <div slot="description">
        <!-- This is an error message about copywriting.1111111111
        ebsList -->
        <div v-if="ebsType !== 'success'">
          <span v-for="(el, index) in ebsList" :key="el.id">{{ el.name }}【{{ el.code }}】{{
            index === ebsList.length - 1 ? "" : "、"
            }}</span>
          库存不存在；
        </div>
        <div style="text-align: left">
          <a @click="closeEbsAlert">{{
            ebsType === "success" ? "我知道了" : "返回修改"
            }}</a>
          <a-divider type="vertical" />
          <a v-if="ebsType === 'success'" @click="() => saveFormula({ key: 2 })">生成产品</a>
          <a v-else @click="copyMsg">复制信息</a>
        </div>
      </div>
    </a-alert>
    <a-spin :spinning="lineLoading || updateLoading" :tip="updateLoading ? null : '配方优化中，请稍后'">
      <a-layout-content class="nhf-editor">
        <a-row justify="space-between" type="flex" class="nhf-header">
          <h1 class="nhf-title" @click="goBack">
            <img class="nhf-logo" :src="logo" alt="返回上一页面" />
            <span class="newTextColor">{{ factoryName }}</span>
          </h1>
          <a-space>
            <a-tooltip>
              <template slot="title"> 全屏显示 </template>
              <a @click="full">
                <img v-if="!isFullScreen" :src="fullScreen" alt="全屏显示" />
                <img v-else :src="exitFullScreen" alt="退出全屏" />
              </a>
            </a-tooltip>
            <!-- <a-divider type="vertical" /> -->
            <a-dropdown>
              <a-button icon="layout" size="small" style="font-size: 22px"></a-button>
              <a-menu slot="overlay" @click="(e) => rightClick({ key: e.key, val: !layout[e.key] })">
                <a-menu-item key="layoutType">切换布局 </a-menu-item>
                <a-menu-divider v-if="layout.layoutType" />
                <a-menu-item v-if="layout.layoutType" key="showSider" class="vue-simple-context-menu__item"><span>配方原料列表
                    <i v-if="layout.showSider" /></span></a-menu-item>
                <a-menu-item v-if="layout.layoutType" key="showRight"
                  class="vue-simple-context-menu__item"><span>配方营养需要量 <i v-if="layout.showRight" /></span></a-menu-item>
                <a-menu-divider />
                <a-menu-item key="addRawActions">添加原料</a-menu-item>
                <a-menu-item key="removeRaw">移除原料</a-menu-item>
                <a-menu-item key="openAddExtraRaw">额外添加原料</a-menu-item>
                <a-menu-divider />
                <a-menu-item key="1">配方优化</a-menu-item>
                <a-menu-item key="2">取整优化</a-menu-item>
                <a-menu-item key="toggleRoundingSet">取整设置</a-menu-item>
                <a-menu-item key="checkEBS" :disabled="detail.formulaSolutionType != 1">EBS校验</a-menu-item>
                <a-menu-item key="saveFormula">生成产品 </a-menu-item>
                <a-menu-item key="togglePorductVisible" :disabled="detail.isProduct == 0">产品对比
                </a-menu-item>
                <a-menu-item key="openDistribution">编辑配销差 </a-menu-item>
              </a-menu>
            </a-dropdown>
            <a-dropdown style="width: 90px" v-if="estimateBtn">
              <a-button size="small" type="default">生长性能预估</a-button>
              <a-menu slot="overlay" @click="changeEstimate">
                <a-menu-item key="1">立即预估</a-menu-item>
                <a-menu-item key="2">历史记录</a-menu-item>
              </a-menu>
            </a-dropdown>
            <a-button v-if="RMPButton" size="small" type="default" @click="openRMPResult">研发成果应用</a-button>
            <a-divider type="vertical" />
            <a-button v-for="el in testBtns" :key="el.id" @click="() => handleTestClick(el)">{{ el.name }}</a-button>
            <a-button size="small" type="primary" @click="changeLinear({ key: 1 })">配方优化</a-button>
            <a-button size="small" @click="changeLinear({ key: 2 })">取整优化</a-button>
            <a-button size="small" @click="openAddExtraRaw">额外添加原料</a-button>
            <a-divider type="vertical" />
            <!-- <a-dropdown style="width: 90px">
              <a-button size="small">配方优化</a-button>
              <a-menu slot="overlay" @click="changeLinear">
                <a-menu-item key="1">仅优化</a-menu-item>
                <a-menu-item key="2">优化取整</a-menu-item>
              </a-menu>
            </a-dropdown> -->
            <a-button :disabled="detail.isProduct == 0" size="small" @click="togglePorductVisible">产品对比</a-button>
            <a-button :disabled="detail.formulaSolutionType != 1" size="small" @click="checkEBS">EBS校验</a-button>
            <!-- <a-dropdown :disabled="!detail.version > 0"> -->
            <a-dropdown>
              <a-button size="small" ghost type="primary">查看报表</a-button>
              <!-- ,'配方产品报表','生产产品报表' -->
              <a-menu slot="overlay" @click="viewReport">
                <a-menu-item :key="index + 1" v-for="(item, index) in [
                  '配方报表',
                  '生产报表',
                  '配方产品报表',
                  '生产产品报表',
                ]">{{ item }}</a-menu-item>
              </a-menu>

              <!-- <a-menu-item key="3">配方产品</a-menu-item>
              <a-menu-item key="4">生产产品</a-menu-item> -->
            </a-dropdown>
            <a-dropdown>
              <a-button size="small" :loading="saveLoading" style="width: 84px" type="primary">保存</a-button>
              <a-menu slot="overlay" @click="saveFormula">
                <a-menu-item v-for="(item, index) in [
                  '仅保存',
                  '更新版本',
                  '生成产品',
                  '保存为原料',
                ]" :key="index">{{ item }}</a-menu-item>
              </a-menu>
            </a-dropdown>
          </a-space>
        </a-row>
        <div class="nhf-container" ref="editorContainer" @contextmenu.prevent.stop="handleMenu($event)">
          <a-row type="flex" align="middle" class="nhf-header-main" justify="space-between">
            <a-space ref="formulaNameRef">
              <a-space>
                <h3 class="formulaNameStyle">{{ detail.formulaName }}</h3>
                <template slot="title">{{ detail.formulaName }}</template>
              </a-space>
              <a-space>
                <a-icon size="small" style="font-size: 15px" @click="toggleEditorVisible" type="form" />
                <a-tooltip>
                  <template slot="title">管理配方组合包</template>
                  <img
                    :src="detail.isStartBag == 1 ? pfBag : pfBagNone"
                    alt="管理配方组合包"
                    :style="{
                      width: '19px',
                      cursor: 'pointer',
                      verticalAlign: 'top'
                    }"
                    @click="toggleFormulaBagVisible"
                  />
                </a-tooltip>
                <a-tooltip>
                  <template slot="title">原料组合包管理</template>
                  <img
                    :src="detail.isStartRawBag == 1 ? rawBag : rawBagNone"
                    alt="原料组合包管理"
                    :style="{
                      width: '19px',
                      cursor: 'pointer',
                      verticalAlign: 'top'
                    }"
                    @click="toggleManageRawBagVisible"
                  />
                </a-tooltip>
              </a-space>
            </a-space>
            <div ref="priceRef" :style="{ display: topPriceType ? 'flex' : 'block' }">
              <a-row type="flex" align="middle" justify="space-between" style="padding: 0">
                <div v-if="detail.moistureVolatilizeStart" style="display: flex;background: rgb(228, 238, 249);height: 100%;margin-bottom: 5px">
                  <img :src="moistureVolatilize" alt="水分挥发" style="margin-left:5px;margin-top:8px;width: 18px; height: 17px;" />
                  <h2 style="margin-left: 5px;color: #1478FF;margin-right: 5px;">{{detail.moistureVolatilizeStart}}</h2>
                </div>
                <a-divider v-if="detail.moistureVolatilizeStart" type="vertical" />
                <div class="col">
                  <div style="display: flex">
                    配销差(元/吨)：{{ formulaPrice }}
                    <a-tooltip style="margin-left: 15px">
                      <template slot="title"> 编辑配销差 </template>
                      <a-icon type="form" @click="openDistribution" size="small" style="
                          font-size: 12px;
                          cursor: pointer;
                          padding-top: 2px;
                          color: #1677ff;
                        " />
                    </a-tooltip>
                  </div>
                  <h2>
                    {{
                    !distributionPriceNum
                    ? "-"
                    : distributionPriceNum.toFixed(titlePriceLen)
                    }}
                    <!-- <span
                        v-if="Number(distributionPriceDiff)"
                        :class="{
                          red: distributionPriceDiff > 0,
                          green: distributionPriceDiff < 0,
                        }"
                      >
                        <b>/</b>{{ Number(distributionPriceDiff).toFixed(titlePriceLen) }}
                        <a-icon style="font-size: 16px" :type="distributionPriceType" />
                      </span> -->
                  </h2>
                  <div v-if="!topPriceType && !!detail.referPriceSource">
                    配销差(元/吨)：{{ distributionPrice }}
                    <h2 class="referencePrice">
                      {{
                      !referDistributionPriceNum &&
                      referDistributionPriceNum !== 0
                      ? "-"
                      : referDistributionPriceNum.toFixed(titlePriceLen)
                      }}
                      <!-- <span
                            v-if="Number(referDistributionPriceDiff)"
                            :class="{
                              red: referDistributionPriceDiff > 0,
                              green: referDistributionPriceDiff < 0,
                            }"
                          >
                            <b>/</b>{{ Number(referDistributionPriceDiff).toFixed(titlePriceLen) }}
                            <a-icon style="font-size: 16px" :type="referDistributionPriceDiffType" />
                          </span> -->
                    </h2>
                  </div>
                  <!-- <p v-if="productPrice.version > 0" style="color: transparent;height: 18px;margin-bottom: 0"></p> -->
                </div>
                <a-divider type="vertical" />
                <div class="col">
                  <!-- 优化价格（元/吨） -->
                  优化成本(元/吨)：{{ formulaPrice }}
                  <h2>
                    {{
                    !detail.price
                    ? Number("0").toFixed(titlePriceLen)
                    : detail.price.toFixed(titlePriceLen)
                    }}
                    <span v-if="computedPrice != 0.0" :class="{
                      red: computedPrice > 0,
                      green: computedPrice < 0,
                    }">
                      <b>/</b>{{ computedPrice }}
                      <a-icon style="font-size: 16px" :type="priceType" />
                    </span>
                  </h2>
                  <div v-if="!topPriceType && !!detail.referPriceSource">
                    配方成本(元/吨)：{{ distributionPrice }}
                    <h2 class="referencePrice">
                      {{
                      !detail.referPrice
                      ? Number(0).toFixed(titlePriceLen)
                      : detail.referPrice.toFixed(titlePriceLen)
                      }}
                      <span v-if="Number(referPriceDiff)" :class="{
                        red: referPriceDiff > 0,
                        green: referPriceDiff < 0,
                      }">
                        <b>/</b>{{ referPriceDiff }}
                        <a-icon style="font-size: 16px" :type="referPriceDiffType" />
                      </span>
                    </h2>
                  </div>
                </div>
                <a-divider type="vertical" />
                <div class="col">
                  <!-- 产品价格（元/吨） -->
                  产品成本(元/吨)：{{ formulaPrice }}
                  <h2>
                    {{
                    !productPrice.price
                    ? Number(0).toFixed(titlePriceLen)
                    : productPrice.price.toFixed(titlePriceLen)
                    }}
                    <span v-if="
                      computedProductPrice != 0.0 && productPrice.version > 0
                    " :class="{
                      red: computedProductPrice > 0,
                      green: computedProductPrice < 0,
                    }">
                      <b>/</b>{{ Number(computedProductPrice).toFixed(titlePriceLen) }}
                      <a-icon style="font-size: 16px" :type="productPriceType" />
                    </span>
                    <span style="
                        font-weight: normal;
                        color: rgba(0, 0, 0, 0.65);
                        font-size: 12px;
                        margin-left: 3px;
                      " v-if="productPrice.version > 0">
                      ({{ productPrice.createTime }}，V{{
                      productPrice.version
                      }})
                    </span>
                  </h2>
                  <div v-if="!topPriceType && !!detail.referPriceSource">
                    产品成本(元/吨)：{{ distributionPrice }}
                    <h2 class="referencePrice">
                      {{
                      !productPrice.referPrice
                      ? Number(0).toFixed(titlePriceLen)
                      : productPrice.referPrice.toFixed(titlePriceLen)
                      }}
                      <span v-if="
                        referComputedPrice != 0.0 && productPrice.version > 0
                      " :class="{
                        red: referComputedPrice > 0,
                        green: referComputedPrice < 0,
                      }">
                        <b>/</b>{{ referComputedPrice }}
                        <a-icon style="font-size: 16px" :type="referComputedPriceDiff" />
                      </span>
                    </h2>
                  </div>
                </div>
              </a-row>
              <a-row type="flex" align="middle" justify="space-between" style="padding: 0"
                v-if="!!detail.referPriceSource && topPriceType">
                <div class="col">
                  配方成本(元/吨)：{{ distributionPrice }}
                  <h2 class="referencePrice">
                    {{
                    !detail.referPrice
                    ? Number(0).toFixed(titlePriceLen)
                    : detail.referPrice.toFixed(titlePriceLen)
                    }}
                    <span v-if="Number(referPriceDiff)" :class="{
                      red: referPriceDiff > 0,
                      green: referPriceDiff < 0,
                    }">
                      <b>/</b>{{ referPriceDiff }}
                      <a-icon style="font-size: 16px" :type="referPriceDiffType" />
                    </span>
                  </h2>
                  <!-- <p v-if="productPrice.version > 0" style="color: transparent;height: 18px;margin-bottom: 0"></p> -->
                </div>
                <a-divider type="vertical" />
                <div class="col">
                  <!-- 产品价格（元/吨） -->
                  配销差(元/吨)：{{ distributionPrice }}
                  <h2 class="referencePrice">
                    {{
                    !referDistributionPriceNum
                    ? "-"
                    : referDistributionPriceNum.toFixed(titlePriceLen)
                    }}
                    <!-- <span
                        v-if="Number(referDistributionPriceDiff)"
                        :class="{
                          red: referDistributionPriceDiff > 0,
                          green: referDistributionPriceDiff < 0,
                        }"
                      >
                        <b>/</b>{{ Number(referDistributionPriceDiff).toFixed(titlePriceLen) }}
                        <a-icon style="font-size: 16px" :type="referDistributionPriceDiffType" />
                      </span> -->
                  </h2>
                </div>
                <a-divider type="vertical" />
                <div class="col">
                  <!-- 优化价格（元/吨） -->
                  产品成本(元/吨)：{{ distributionPrice }}
                  <h2 class="referencePrice">
                    {{
                    !productPrice.referPrice
                    ? Number(0).toFixed(titlePriceLen)
                    : productPrice.referPrice.toFixed(titlePriceLen)
                    }}
                    <span v-if="
                      referComputedPrice != 0.0 && productPrice.version > 0
                    " :class="{
                      red: referComputedPrice > 0,
                      green: referComputedPrice < 0,
                    }">
                      <b>/</b>{{ referComputedPrice }}
                      <a-icon style="font-size: 16px" :type="referComputedPriceDiff" />
                    </span>
                  </h2>
                  <!-- <p v-if="productPrice.version > 0" style="color: transparent;height: 18px;margin-bottom: 0"></p> -->
                </div>
                <!-- <a-tooltip v-if="topPriceType">
                    <template slot="title">
                      编辑配销差
                    </template>
                    <a-icon type="form"  @click="openDistribution" size="small" style="font-size: 15px;cursor: pointer;" />
                  </a-tooltip> -->
              </a-row>
            </div>
          </a-row>
          <!-- layout 1 -->
          <div class="nhf-layout" ref="box" style="overflow: hidden" v-if="layout.layoutType">
            <div class="tableleft" :style="leftStyle" v-show="layout.showSider">
              <raw-editor @refreshNutrition="refreshNutrition" @refresh="refreshUpdate" @prcieChange="prcieChange"
                ref="rawBlock" @add="toggleRawPanel" @countPrice="countPrice">
                <a-space class="icon-bar">
                  <!-- <a-button size="small" ghost @click="toggleHidden('rawRows')" type='primary' :disabled="!rawRows.length">原料养分控制</a-button> -->
                  <!-- <a-button :disabled="!rawRows.length > 0 || !(rawRows.length > 0 && rawRows[0].percentage > 0)" size="small" @click="toggleHasAnalyse" type='primary'>梯度分析</a-button> -->
                  <a-tooltip>
                    <template slot="title">创建原料组合包</template>
                    <a-badge :count="rawRows.length">
                      <a-button type="link" @click="openCreateRawBag">
                        <img :src="rawBagNone" alt="创建原料组合包" />
                      </a-button>
                    </a-badge>
                  </a-tooltip>
                  <a-tooltip>
                    <template slot="title">原料过滤</template>
                    <a-dropdown>
                      <!-- <a-button type="link" icon="control" /> -->
                      <a-button type="link">
                        <img :src="filterMaterial" alt="原料过滤" />
                      </a-button>
                      <a-menu slot="overlay" class="menu">
                        <!-- <a-radio-group
                          :defaultValue="rawTypeSelect"
                          :options="rawTypesRadio"
                          @change="(e) => setRawTypeSelect(e.target.value)"
                        /> -->
                        <a-menu-item>
                          <span :style="{
                            color: rawTypeSelect === 0 ? '#1890ff' : '',
                          }" @click="() => setRawTypeSelect(0)">所有原料</span>
                        </a-menu-item>
                        <a-menu-item>
                          <span :style="{
                            color: rawTypeSelect === 1 ? '#1890ff' : '',
                          }" @click="() => setRawTypeSelect(1)">组分原料</span>
                        </a-menu-item>
                        <a-menu-item>
                          <span :style="{
                            color: rawTypeSelect === 2 ? '#1890ff' : '',
                          }" @click="() => setRawTypeSelect(2)">拒绝原料</span>
                        </a-menu-item>
                      </a-menu>
                    </a-dropdown>
                  </a-tooltip>
                  <a-tooltip>
                    <template slot="title">取整参数设置</template>
                    <a-button type="link" @click="toggleRoundingSet">
                      <img :src="rounding" alt="取整参数设置" />
                    </a-button>
                  </a-tooltip>
                  <a-tooltip>
                    <template slot="title">梯度分析</template>
                    <!-- <a-button
                      type="link"
                      icon="area-chart"
                      :disabled="rawRows.length != 1"
                      @click="toggleHasAnalyse"
                    /> -->
                    <a-button type="link" :disabled="rawRows.length != 1" @click="toggleHasAnalyse">
                      <img :src="gradientAnalysis" alt="梯度分析" />
                    </a-button>
                  </a-tooltip>
                  <table-filter-col type="raw" />
                </a-space>
              </raw-editor>
            </div>
            <div v-show="layout.showSider && layout.showRight" class="resize" :style="{
              height: detail.referPriceSource
                ? 'calc(100vh - 170px)'
                : 'calc(100vh - 125px)',
            }" title="左右拖动调整宽度" />
            <div v-show="layout.showRight" class="tableright" :style="rightStyle">
              <nutrition-editor @refresh="refreshUpdate" ref="nutritionBlock" @res="getDetail" />
            </div>
          </div>
          <!-- layout 2 -->
          <a-tabs @change="tabChange" :activeKey="tabSelect" :animated="false" v-else>
            <a-tab-pane key="1" tab="配方原料" :forceRender="true">
              <raw-editor @refreshNutrition="refreshNutrition" @refresh="refreshUpdate" @prcieChange="prcieChange"
                ref="rawBlock" @add="toggleRawPanel" @countPrice="countPrice" />
            </a-tab-pane>
            <a-tab-pane key="2" tab="配方营养需要量" :forceRender="true">
              <nutrition-editor @refresh="refreshUpdate" ref="nutritionBlock" @res="getDetail" />
            </a-tab-pane>
            <a-space slot="tabBarExtraContent" class="icon-bar">
              <template v-if="tabSelect == 1">
                <a-tooltip>
                  <template slot="title">添加原料</template>
                  <!-- <a-button
                    type="link"
                    icon="file-add"
                    @click="addRawActions"
                  /> -->
                  <a-button type="link" @click="addRawActions">
                    <img :src="addImg" alt="添加原料" />
                  </a-button>
                </a-tooltip>
                <a-tooltip>
                  <template slot="title">移出原料</template>
                  <a-badge :count="rawRows.length">
                    <!-- <a-button
                      icon="delete"
                      type="link"
                      :disabled="rawRows.length == 0"
                      @click="removeRaw"
                    /> -->
                    <a-button type="link" :disabled="rawRows.length === 0" @click="removeRaw">
                      <img :src="deleteImg" alt="移出原料" />
                    </a-button>
                  </a-badge>
                </a-tooltip>
                <a-tooltip>
                  <template slot="title">创建原料组合包</template>
                  <a-badge :count="rawRows.length">
                    <a-button type="link" @click="openCreateRawBag">
                      <img :src="rawBagNone" alt="创建原料组合包" />
                    </a-button>
                  </a-badge>
                </a-tooltip>
              </template>
              <!-- <a-button v-if="tabSelect ==1" size="small" @click="toggleHidden('rawRows')" :disabled="!rawRows.length">原料养分控制</a-button>
              <a-button v-if="tabSelect ==2" size="small" @click="toggleHidden('nutRows')" :disabled="!nutRows.length">营养养分控制</a-button> -->
              <a-tooltip v-if="tabSelect == 2">
                <template slot="title">养分选择表</template>
                <!-- <a-button
                  type="link"
                  icon="fork"
                  @click="toggleVisible('nutChoose')"
                /> -->
                <a-button type="link" @click="toggleVisible('nutChoose')">
                  <img :src="nutrientSelection" alt="养分选择表" />
                </a-button>
              </a-tooltip>
              <a-tooltip v-if="tabSelect == 1">
                <template slot="title">取整参数设置</template>
                <a-button type="link" @click="toggleRoundingSet">
                  <img :src="rounding" alt="取整参数设置" />
                </a-button>
              </a-tooltip>
              <a-tooltip v-if="tabSelect == 1">
                <template slot="title">梯度分析</template>
                <!-- <a-button
                  type="link"
                  icon="area-chart"
                  :disabled="rawRows.length != 1"
                  @click="toggleHasAnalyse"
                /> -->
                <a-button type="link" :disabled="rawRows.length != 1" @click="toggleHasAnalyse">
                  <img :src="gradientAnalysis" alt="梯度分析" />
                </a-button>
              </a-tooltip>
              <a-tooltip v-if="tabSelect == 1">
                <template slot="title">原料过滤</template>
                <a-dropdown>
                  <!-- <a-button type="link" icon="control" /> -->
                  <img :src="filterMaterial" alt="原料过滤" />
                  <a-menu slot="overlay" class="menu">
                    <!-- <a-radio-group
                      :defaultValue="rawTypeSelect"
                      :options="rawTypesRadio"
                      @change="(e) => setRawTypeSelect(e.target.value)"
                    /> -->
                    <a-menu-item>
                      <span :style="{ color: rawTypeSelect === 0 ? '#1890ff' : '' }"
                        @click="() => setRawTypeSelect(0)">所有原料</span>
                    </a-menu-item>
                    <a-menu-item>
                      <span :style="{ color: rawTypeSelect === 1 ? '#1890ff' : '' }"
                        @click="() => setRawTypeSelect(1)">组分原料</span>
                    </a-menu-item>
                    <a-menu-item>
                      <span :style="{ color: rawTypeSelect === 2 ? '#1890ff' : '' }"
                        @click="() => setRawTypeSelect(2)">拒绝原料</span>
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
              </a-tooltip>
              <table-filter-col type="raw" v-if="tabSelect == 1" />
              <nut-filter-value @change="filterNut" v-if="tabSelect == 2" />
              <table-filter-col type="nut" v-if="tabSelect == 2" />
            </a-space>
          </a-tabs>
        </div>
      </a-layout-content>
      <!-- <product-modal :hidden="productVisible" @cancel="togglePorductVisible" /> -->
      <product-comparison :hidden="productVisible" @cancel="togglePorductVisible" :productPrice="productPrice" />
      <compound-create-modal @ok="update" @cancel="toggleEditorVisible" :hidden="editorVisible" />
      <analyse-modal :rawitem="rawRows" :hidden="analyseVisible" @close="toggleAnalyse" />
      <vue-simple-context-menu :elementId="'layoutMenu'" :options="layoutOption" ref="contextMenuContainer"
        @option-clicked="menuChecked" />
      <raw-save-modal @ok="refreshPage" />
    </a-spin>
    <estimated-confirm-modal />
    <check-EBS :visible="ebsPushVisible" @close="closeCheckEBS" @checkEbsRes="checkEbsRes" />
    <update-animal-modal :hidden="updateAnimalVisible" @close="closeUpdateAnimal" />
    <!-- 更新版本自定义弹窗 -->
    <a-modal
      :visible="updateVersionVisible"
      title="保存提醒"
      :destroyOnClose="true"
      :maskClosable="false"
      :confirmLoading="saveLoading"
      :okText="'保存并更新版本'"
      :cancelText="'取消'"
      @ok="handleUpdateVersionOk"
      @cancel="() => (updateVersionVisible = false)"
    >
      <a-alert
        type="warning"
        showIcon
        message="配方没有进行优化，或者优化后无解的情况，无法更新配方版本。"
        style="margin-bottom: 16px;"
      />
      <div style="margin-bottom: 12px;">版本号：{{ displayNextVersion }}</div>
      <a-form-model :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
        <a-form-model-item label="备注:">
          <a-textarea
            v-model="remark"
            :maxLength="150"
            :autoSize="{ minRows: 3, maxRows: 5 }"
            placeholder="输入备注信息"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <extra-raw-info :visible="extraRawVisible" :detail="detail" @close="closeAddExtraRaw" />
    <DistributionDifference :hide="distributionVisible" @close="closeDistribution" :detail="distributionDetailObj"
      :formulaId="formulaId" />
    <result-modal :hidden="resultModalVisible" @close="resultModalClose" :params="linearData" />
    <SetClass @refreshDetail="getDetail" />

    <RMP-result-drawer :hidden="!RMPVisible" :fid="formulaId" @close="closeRMPModal" />
    <!-- 其他组件内容 -->
    <RoundingSetModal :formula-id="formulaId" :roundingVisible="roundingSetVisible" @close="toggleRoundingSet" />
    <FormulaBag :visible="formulaBagVisible" @close="toggleFormulaBagVisible" @refresh="handleFormulaBagRefresh" :formulaId="formulaId" />
    <CreateRawBag :visible="createRawBagVisible" :selectedRaws="rawRows" :formulaId="formulaId" @close="toggleCreateRawBag" @success="handleCreateRawBagSuccess" @refresh="handleManageRawBagRefresh" />
    <ManageRawBag ref="manageRawBag" :visible="manageRawBagVisible" @close="toggleManageRawBagVisible" :formulaId="formulaId" @refresh="handleManageRawBagRefresh" />
  </a-layout>
</template>

<script>
import { nhfMixins } from "../untils";
import logo from "../../../assets/images/logo_nhf.svg";
import fullScreen from '@/assets/images/icon/fullScreen.png';
import exitFullScreen from '@/assets/images/icon/exitFullScreen.png';
import filterMaterial from '@/assets/images/icon/filterMaterial.png';
import gradientAnalysis from '@/assets/images/icon/gradientAnalysis.png';
import rounding from '@/assets/images/icon/rounding.png';
import moistureVolatilize from '@/assets/images/icon/moistureVolatilize.png';
import nutrientSelection from '@/assets/images/icon/nutrientSelection.png';
import addImg from '@/assets/images/icon/add.png';
import deleteImg from '@/assets/images/icon/delete.png';
import rawBagNone from '@/assets/images/icon/raw_bag_none.png';
import rawBag from '@/assets/images/icon/raw_bag.png';
import pfBag from '@/assets/images/icon/pf_bag.png';
import pfBagNone from '@/assets/images/icon/pf_bag_none.png';
import NutritionEditor from "./editor/NutritionEditor.vue";
import RawEditor from "./editor/RawEditor.vue";
import AnalyseModal from "./modal/AnalyseModal.vue";
import CompoundCreateModal from "./modal/CompoundCreateModal.vue";
// import ProductModal from "./modal/ProductModal.vue";
import VueSimpleContextMenu from "vue-simple-context-menu";
import TableFilterCol from "./editor/TableFilterCol.vue";
import NutFilterValue from "./editor/NutFilterValue.vue";
import rawColumns from "./editor/rawColumns";
import nutColumns from "./editor/nutColumns";
import "vue-simple-context-menu/dist/vue-simple-context-menu.css";
import RawSaveModal from "./modal/RawSaveModal.vue";
import { getRequest } from "@/components/Common/Utils/Utils";
import EstimatedConfirmModal from './modal/EstimatedConfirmModal.vue';
import ProductComparison from './modal/ProductComparison.vue';
import CheckEBS from './modal/CheckEBS.vue';
import UpdateAnimalModal from './modal/UpdateAnimalModal.vue';
import ExtraRawInfo from './modal/ExtraRawInfo.vue';
import DistributionDifference from './modal/DistributionDifference.vue';
import ResultModal from './modal/ResultModal.vue';
import SetClass from './modal/SetClass.vue';
// import {trackUrl} from '@/Utils/url'
// import {NsTrack} from '../../../Utils/track/track'
import RMPResultDrawer from "../components/RMPResultDrawer.vue";
import RoundingSetModal from './modal/RoundingSetModal.vue'; // 引入 RoundingSetModal 组件
import FormulaBag from './modal/FormulaBag.vue'; // 引入 FormulaBag 组件
import CreateRawBag from './modal/CreateRawBag.vue'; // 引入 CreateRawBag 组件
import ManageRawBag from './modal/ManageRawBag.vue'; // 引入 ManageRawBag 组件

export default {
  components: {
    NutritionEditor,
    RawEditor,
    // ProductModal,
    CompoundCreateModal,
    AnalyseModal,
    VueSimpleContextMenu,
    TableFilterCol,
    RawSaveModal,
    NutFilterValue,
    EstimatedConfirmModal,
    ProductComparison,
    CheckEBS,
    UpdateAnimalModal,
    ExtraRawInfo,
    DistributionDifference,
    ResultModal,
    SetClass,
    // NsTrack,
    RMPResultDrawer,
    RoundingSetModal, // 注册 RoundingSetModal 组件
    FormulaBag, // 注册 FormulaBag 组件
    CreateRawBag, // 注册 CreateRawBag 组件
    ManageRawBag, // 注册 ManageRawBag 组件
  },
  mixins: [nhfMixins],
  computed: {
    displayNextVersion() {
      const current = Number(this.detail && this.detail.version ? this.detail.version : 0);
      if (isNaN(current)) {
        return this.detail && this.detail.version ? `V${this.detail.version}` : 'V1';
      }
      const next = current >= 0 ? current + 1 : 1;
      return `V${next}`;
    },
    formulaPrice() {
      let priceObj = {
        '1': '合同价格',
        '2': '预测价格',
        '3': '库存价格',
        '4': '市场价格',
      };
      let { priceSource } = this.detail || {};
      return priceSource ? priceObj[priceSource] : '';
    },
    distributionPrice() {
      let priceObj = {
        '1': '合同价格',
        '2': '预测价格',
        '3': '库存价格',
        '4': '市场价格',
      };
      let { referPriceSource } = this.detail || {};
      return referPriceSource ? priceObj[referPriceSource] : '';
    },
    leftStyle() {
      const { leftHalfWidth } = this;
      const { showRight, showSider, layoutType } = this.layout;
      let width = showRight && leftHalfWidth ? `${leftHalfWidth}px` : "";
      if (!showRight && !showSider) width = "100%";
      return {
        width,
        float: layoutType && showSider && !showRight ? "none" : "left",
      };
    },
    rightStyle() {
      const { rightHalfWidth } = this;
      const { showRight, showSider } = this.layout;
      let width = '';
      if (showSider && showRight && rightHalfWidth) {
        width = `${rightHalfWidth}px`;
      }
      if (!showSider && showRight && rightHalfWidth) {
        width = '100%';
      }
      if (!showRight) width = '';
      return {
        width,
      };
    },
    layoutOption() {
      const {
        showSider,
        showRight, layoutType } = this.layout;
      const item = [
        {
          type: "divider",
        },
        {
          name: `<b>配方原料列表</b> ${showSider ? "<i />" : ""}`,
          commit: "showSider",
        },
        {
          name: `<b>配方营养需要量</b> ${showRight ? "<i />" : ""}`,
          commit: "showRight",
        },
      ];
      const base = [
        {
          name: `切换布局`,
          commit: "layoutType",
        },
      ];
      const other = [
        {
          type: "divider",
        },
        {
          name: `添加原料`,
          commit: 'addRawActions'
        },
        {
          name: `移除原料`,
          commit: this.rawRows.length !== 0 ? 'removeRaw': '',
          class: this.rawRows.length === 0 ? 'disabledMenu' : ''
        },
        {
          type: "divider",
        },
        {
          name: `配方优化`,
          commit: "1",
        },
        {
          name: `取整优化`,
          commit: "2",
        },
        {
          name: `取整设置`,
          commit: "toggleRoundingSet",
        },
        {
          type: "divider",
        },
        {
          name: `额外添加原料`,
          commit: 'openAddExtraRaw'
        },
        {
          name: `编辑配销差`,
          commit: 'openDistribution'
        },
        {
          type: "divider",
        },
        {
          name: `EBS校验`,
          commit: this.detail.formulaSolutionType == 1 ? "checkEBS" : '',
          class: this.detail.formulaSolutionType == 1 ? "" : 'disabledMenu'
        },
        {
          name: `生成产品`,
          commit: "saveFormula",
        },
        {
          name: `产品对比`,
          commit: this.detail.isProduct != 0 ? "togglePorductVisible" : '',
          class: this.detail.isProduct != 0 ? "" : 'disabledMenu'
        },
      ];
      return layoutType ? [...base, ...item, ...other] : [...base, ...other];
    },
    computedPrice() {
      const { price, lastPrice } = this.detail;
      return lastPrice != null && price != null
        ? (price - lastPrice).toFixed(this.titlePriceLen)
        : "";
    },
    priceType() {
      return Number(this.computedPrice) > 0 ? "arrow-up" : "arrow-down";
    },
    computedProductPrice() {
      let { price } = this.productPrice;
      let { price: detailsPrice } = this.detail;
      return price != null && detailsPrice != null
        ? (-price + detailsPrice).toFixed(this.titlePriceLen)
        : "";
    },
    referComputedPrice() {
      let { referPrice } = this.productPrice;
      let { referPrice: detailsPrice } = this.detail;
      return referPrice != null && detailsPrice != null
        ? (-referPrice + detailsPrice).toFixed(this.titlePriceLen)
        : 0;
    },
    referComputedPriceDiff() {
      return Number(this.referComputedPrice) > 0 ? "arrow-up" : "arrow-down";
    },
    productPriceType() {
      return Number(this.computedProductPrice) > 0 ? "arrow-up" : "arrow-down";
    },
    distributionPriceDiff() {
      let { distributionLastPrice } = this.distributionDetailObj || {};
      return distributionLastPrice != null && this.distributionPriceNum != null ?
        (this.distributionPriceNum - distributionLastPrice).toFixed(this.titlePriceLen) :
        0;
    },
    distributionPriceType() {
      return Number(this.distributionPriceDiff) > 0 ? "arrow-up" : "arrow-down";
    },
    referDistributionPriceDiff() {
      let { referDistributionLastPrice } = this.distributionDetailObj || {};
      return referDistributionLastPrice != null && this.referDistributionPriceNum != null ?
        (this.referDistributionPriceNum - referDistributionLastPrice).toFixed(this.titlePriceLen) :
        '';
    },
    referDistributionPriceDiffType() {
      return Number(this.referDistributionPriceDiff) > 0 ? "arrow-up" : "arrow-down";
    },
    referPriceDiff() {
      let { referPrice, referLastPrice } = this.detail || {};
      return referPrice != null && referLastPrice != null ?
        (referPrice - referLastPrice).toFixed(this.titlePriceLen) :
        '';
    },
    referPriceDiffType() {
      return Number(this.referPriceDiff) > 0 ? "arrow-up" : "arrow-down";
    },
    distributionPriceNum() {
      // 净销价格 - 包材价格 - 配方优化成本 / 投入产出比
      let { netSellingPrice = 0, packageMaterialPrice = 0, inputOutputRatio = 0 } = this.distributionDetailObj || {};
      let { price = 0 } = this.detail || {};
      let num = netSellingPrice - packageMaterialPrice - (price / ((inputOutputRatio / 100) || 1));
      if (!inputOutputRatio) num = null;
      return num;
    },
    referDistributionPriceNum() {
      // 净销价格 - 包材价格 - 配方优化成本 / 投入产出比
      let { netSellingPrice = 0, packageMaterialPrice = 0, inputOutputRatio = 0 } = this.distributionDetailObj || {};
      let { referPrice = 0 } = this.detail || {};
      let num = netSellingPrice - packageMaterialPrice - (referPrice / (inputOutputRatio / 100 || 1));
      if (!inputOutputRatio) num = null;
      return num;
    },
  },
  data() {
    return {
      ebsList: [],
      ebsIsFalse: false,
      ebsMessage: '请注意！',
      ebsType: 'warning',
      rawColumns, nutColumns,
      logo, fullScreen, exitFullScreen, filterMaterial, gradientAnalysis,rounding,moistureVolatilize, nutrientSelection, addImg, deleteImg, rawBagNone, rawBag, pfBag, pfBagNone, // icon
      editorContainerHeight: 400,
      updateAnimalVisible: false,
      ebsPushVisible: false,
      resultModalVisible: false,
      resultVisible: false,
      saveLoading: false,
      productVisible: false,
      editorVisible: false,
      lineLoading: false,
      saveVisible: false,
      goodLoading: false,
      rawVisible: false,
      nutritenVisible: false,
      nutritenDetailVisible: false,
      needVisible: false,
      updateLoading: false,
      analyseVisible: false,
      extraRawVisible: false,
      distributionVisible: false,
      updateVersionVisible: false,
      remark: '',
      refreshNoticeCompound: null,
      leftHalfWidth: null,
      rightHalfWidth: null,
      needType: null,
      linearData: {},
      form: {},
      top: 0,
      productPrice: 0,
      tabSelect: "1",
      factoryName: window.localStorage.getItem("factoryName"), //工厂名称
      id: getRequest("id"), //保存当前路由id
      estimateBtn: false,// 立即预估按钮显示隐藏
      testBtns: [], // 测试按钮
      isFirst: true,
      distributionDetailObj: {},
      titlePriceLen: 1,
      formulaId: '',
      topPriceType: false,
      userInfo: {},

      RMPButton: false,
      RMPVisible: false,
      roundingSetVisible: false, // 控制 RoundingSetModal 显示状态
      formulaBagVisible: false, // 控制配方组合包弹窗显示状态
      createRawBagVisible: false, // 控制创建原料组合包弹窗显示状态
      manageRawBagVisible: false, // 控制原料组合包管理抽屉显示状态
    };
  },
  mounted() {
    let user = window.localStorage.getItem('userInfo');
    if (user) {
      setTimeout(() => {
        this.setUserInfo(JSON.parse(user));
      }, 1000);
    }
    // this.setUserInfo()
    this.contrastTargetAddDiff();
    // if(!this.layout.layoutType) {
    //   this.initSize();
    //   this.getContainerHeight();
    //   this.init()
    // }
    this.initFormulaCache(1);
    window.document.addEventListener("keydown", this.listenKeyCode);
  },
  beforeDestroy() {
    clearInterval(this.refreshNoticeCompound);
    this.refreshNoticeCompound = null;
  },
  watch: {
    "layout.layoutType"(val) {
      this.initSize();
      this.getContainerHeight();
      this.init();
      if (this.isFirst) {
        this.handleLayout({ key: 'layoutType', val });
        this.isFirst = false;
      }
    },
  },
  methods: {
    handleUpdateVersionOk() {
      this.formulaProduct();
      this.updateVersionVisible = false;
    },
    handleTestClick(r) {
      this[r.path](r.code === 'third-test-optimize' ? 1 : 2);
    },
    async testOptimize(optimizationType) {
      let params = {
        formulaId: this.formulaId, optimizationType
      };
      await this.$http.get('/nhf-app/formulaRemoteCalCusStruct/linearOptimizationCusStruct', { params });
      this.refreshPage();
    },
    setUserInfo(data) {
      let { userId, userName, email, code: userNo, userType, phoneNumber, clientId, } = data || {};
      this.userInfo = {
        userName,
        userId,
        email,
        userNo,
        userType,
        phoneNumber,
        clientId,
      };
    },
    resultModalClose(type) {
      if (type) this.init();
      this.resultModalVisible = false;
    },
    detailWidth() {
      let e = this.$refs.editorContainer.offsetWidth;
      let f = this.$refs.formulaNameRef.offsetWidth;
      let p = this.$refs.priceRef.offsetWidth;
      if (!this.topPriceType) {
        this.topPriceType = e >= f + p * 2;
      } else {
        this.topPriceType = e >= f + p;
      }
    },
    async getDistributionDetail() {
      let res = await this.fetchGet({
        actions: this.distributionDetail,
        data: { formulaId: this.formulaId }
      });
      let { success, data } = res || {};
      if (success) {
        this.distributionDetailObj = data;
      } else {
        this.distributionDetailObj = {};
      }
    },
    openAddExtraRaw() {
      this.extraRawVisible = true;
    },
    closeAddExtraRaw(type) {
      if (type) this.init();
      this.extraRawVisible = false;
    },
    openDistribution() {
      this.distributionVisible = true;
    },
    closeDistribution(type) {
      if (type) this.init();
      this.distributionVisible = false;
    },
    copyMsg() {
      let random = '';
      // {{el.name}}【{{el.code}}】{{index === ebsList.length - 1 ? '' : '、'}}
      this.ebsList.forEach((el, index) => {
        random += `${el.name}【${el.code}】${this.ebsList.length - 1 === index ? '' : ';'}`;
      });
      random += 'EBS校验不通过';
      const input = window.document.createElement('textarea');
      window.document.body.appendChild(input);
      input.innerHTML = random;
      // input.setAttribute('value',random);
      // input.select();
      input.setAttribute('code', 1);
      input.select();
      window.document.execCommand("Copy");
      this.$message.success('复制成功');
      this.closeEbsAlert();
    },
    closeCheckEBS() {
      // if(type) this.init()
      this.ebsPushVisible = false;
    },
    checkEBS() {
      let params = {
        factoryId: window.localStorage.getItem('factoryId')
      };
      this.$http.get('/iot-factory/factorysublink/subFactoryList', { params }).then(res => {
        let { data, success } = res || {};
        if (success) {
          this.$confirm({
            title: 'EBS校验',
            content: '校验配方组分原料在工厂库存组织中是否存在？',
            cancelText: '取消',
            okText: '继续',
            onOk: async () => {
              if (data.length > 0) {
                this.ebsPushVisible = true;
              } else {
                let params = {
                  formulaId: this.formulaId,
                  ebsPushFactoryId: window.localStorage.getItem('factoryId')
                };
                this.$http.get('/nhf-app/formulaNhf/batchFormulaRawEbsCheck', { params }).then(res => {
                  let { data: msgData } = res || {};
                  this.checkEbsRes(msgData);
                });
              }
            },
          });
        }
      });

    },

    checkEbsRes(data) {
      if (data.length === 0) {
        this.ebsIsFalse = true;
        this.ebsMessage = '校验通过！';
        this.ebsType = 'success';
        this.$message.success('校验成功');
      } else {
        this.ebsList = data || [];
        this.ebsIsFalse = true;
        this.ebsMessage = '请注意！';
        this.ebsType = 'warning';
      }
    },
    closeEbsAlert() {
      this.ebsList = [];
      this.ebsMessage = '';
      this.ebsType = '';
      this.ebsIsFalse = false;
    },
    listenKeyCode(e) {
      if (e.altKey && e.keyCode === 79) this.changeLinear({ key: 1 }); // 配方优化: 组合键 alt + o
      if (e.altKey && e.keyCode === 76) this.changeLinear({ key: 2 }); // 取整优化: 组合键 alt + l
    },
    refreshNutrition() {
      this.$refs.nutritionBlock && this.$refs.nutritionBlock.getList();
    },
    async updateModal() {
      let data = {
        formulaId: this.id
      };
      await this.fetchGet({
        actions: this.contrastTargetModelAddDiff,
        data,
      });
      this.getContainerHeight();
      this.initMounted();
    },
    contrastTargetAddDiff() {
      let params = {
        formulaId: this.id
      };
      this.$http.get('/nhf-app/formulaManage/contrastTargetAddDiff', { params }).then(res => {
        let { success } = res || {};
        if (success) {
          this.updateModal();
        }
      });
    },
    initFormulaCache(force = 0) {
      let params = {
        formulaId: this.id,
        force
      };
      this.$http.get('/nhf-app/formulaManage/initFormulaCache', { params });
    },
    initMounted() {
      this.$nextTick(() => {
        this.getContainerHeight();
        this.initSize();
        this.init();
      });
      this.setState({
        visible: {
          raw: false,
          nut: false,
          nut2: false,
          result: false,
          result2: false,
          nutChoose: false,
          raw2: false,
          saveRaw: false,
          estimated: false,
          nhfEstimateData: {}
        }
      });
      this.getFactoryDetails();
      let layoutType = window.localStorage.getItem('layoutType');
      let showSider = window.localStorage.getItem('showSider');
      let showRight = window.localStorage.getItem('showRight');
      let rawTypeSelect = window.localStorage.getItem('rawTypeSelect');
      this.mountedHandleLayout({ key: 'layoutType', val: layoutType === 'layoutType' ? true : false });
      if (showSider) {
        this.mountedHandleLayout({ key: 'showSider', val: showSider !== 'setFalse' });
      } else {
        this.mountedHandleLayout({ key: 'showSider', val: true });
      }
      if (showRight) {
        this.mountedHandleLayout({ key: 'showRight', val: showRight !== 'setFalse' });
      } else {
        this.mountedHandleLayout({ key: 'showRight', val: true });
      }
      if (rawTypeSelect) this.setRawTypeSelect(Number(rawTypeSelect));
      // 获取按钮权限
      this.getBtn();
      this.getNutrition();
    },
    async countPrice({ val, referVal }) {
      let mix = Math.abs((this.detail.price || 0) - (val || 0)) > 0.01;
      let referMix = Math.abs((this.detail.referPrice || 0) - (referVal || 0)) > 0.01;
      if (mix || referMix) {
        this.detail.price = Number(val) || 0;
        // this.detail.referPrice = this.detail.referPriceSource ? Number(referVal) || 0 : null
        this.detail.referPrice = Number(referVal) || 0;
        if (this.referPriceSourceChange || referMix) {
          await this.changeReferDistributionPriceNum();
          this.setState({ referPriceSourceChange: false });
        }
        if (this.priceSourceChange || mix) {
          await this.changeDistributionPrice();
          this.setState({ priceSourceChange: false });
        }
        await this.updatePrice(this.detail);
        this.$nextTick(() => {
          console.log('refreshUpdateById-before', this.detail.id);
          this.refreshUpdateById(this.detail.id);
          console.log('refreshUpdateById-after', this.detail.id);
        });
      }
    },
    async changeReferPrice(referVal) {
      await this.fetchPost({
        actions: this.updateFormulaReferPrice,
        data: {
          referPrice: referVal,
          id: getRequest('id')
        },
        showMessage: false,
      });
    },
    async changeDistributionPrice() {
      if (!this.distributionDetailObj.id) {
        return;
      }
      await this.fetchPost({
        actions: this.updateOnlyFormulaDistributionDiffPrice,
        data: {
          distributionPrice: this.distributionPriceNum,
          distributionLastPrice: this.distributionDetailObj.distributionPrice,
          id: this.distributionDetailObj.id
        },
        showMessage: false,
      });
    },
    async changeReferDistributionPriceNum() {
      if (!this.distributionDetailObj.id) {
        return;
      }
      await this.fetchPost({
        actions: this.updateOnlyFormulaDistributionDiffReferPrice,
        data: {
          referDistributionPrice: this.referDistributionPriceNum,
          referDistributionLastPrice: this.distributionDetailObj.referDistributionPrice,
          id: this.distributionDetailObj.id
        },
        showMessage: false,
      });
    },
    async updatePrice(data) {
      await this.fetchPost({
        actions: this.formulaManageUpdate,
        // loading: "updateLoading",
        data,
      });
      await this.getDetail();
      await this.getDistributionDetail();
    },
    getNutrition() {
      this.$get('/nhf-core-data/animalnutrition/animalNutritionUserPage', { size: 1000, current: 1 }).then(res => {
        let { success, data } = res || {};
        if (success) {
          let { records } = data || {};
          this.setState({ nutritionList: records });
        }
      });
    },
    getBtn() {
      let factoryId = window.localStorage.getItem('factoryId');
      if (!factoryId) return;
      this.$http.get("/iot-system/menu/buttons", { params: { controlEnd: false, factoryId } }).then(res => {
        let { success, data } = res;
        if (success) {
          this.testBtns = [];
          data && data.forEach(el => {
            if (el.path === '/nhf/compound-feed') {
              el.children && el.children.forEach(item => {
                if (item.code === 'third-RMP-apply') this.RMPButton = true;
                if (item.code === 'third-estimate') this.estimateBtn = true;
                if (item.code.indexOf('third-test') >= 0) this.testBtns.push(item);
              });
            }
          });
        }
      });
    },
    setRawTypeSelect(rawTypeSelect) {
      this.setState({ rawTypeSelect });
      window.localStorage.setItem('rawTypeSelect', rawTypeSelect);
    },
    getFactoryDetails() {
      let id = window.localStorage.getItem('factoryId');
      if (!id) {
        this.$get('/iot-factory/factory/detail', { id }).then(res => {
          let { success, data } = res || {};
          if (success) {
            let { overseasFlag } = data || {};
            this.overseasFlag = overseasFlag;
            if (overseasFlag != window.localStorage.getItem('overseasFlag')) {
              window.localStorage.setItem('overseasFlag', overseasFlag);
            }
          }

          // 存一个工厂的详细信息
          window.localStorage.setItem('factoryDetail', JSON.stringify(data));
        });
      }
    },
    initSize() {
      this.$nextTick(() => {
        const width = this.$refs["editorContainer"]
          ? this.$refs["editorContainer"].offsetWidth
          : null;
        if (width) {
          this.leftHalfWidth = (width - 6) * 0.6;
          this.rightHalfWidth = (width - 6) * 0.4;
        }
      });
    },
    filterNut(val) {
      this.$refs["nutritionBlock"].filterList(val);
    },
    async init() {
      const { id } = this.$route.query;
      this.formulaId = id;
      this.refreshPage();
      window.onresize = () => {
        this.getContainerHeight();
        this.initSize();
      };
      this.dragControllerDiv();
      this.getDistributionDetail();
    },
    removeRaw() {
      this.$refs["rawBlock"].removeRaw();
    },
    addRawActions() {
      this.$refs["rawBlock"].toggleRawVisible();
    },
    goBack() {
      this.$router.push("/nhf/compound-feed?name=配合饲料");
    },
    mountedHandleLayout(e) {
      this.toggleLayout({ feild: e.key, val: e.val });
    },
    rightClick(e) {
      let { key } = e || {};
      if (key === '1' || key === '2') {
        this.changeLinear({ key });
      } else if (key === 'saveFormula') {
        this.saveFormula({ key: 2 });
      } else if (key === 'showSider' || key === 'showRight' || key === 'layoutType') {
        this.handleLayout(e);
      } else {
        this[key]();
      }
    },
    handleLayout(e) {
      let { key, val } = e || {};
      let feildObj = {
        showRight: 'showSider',
        showSider: 'showRight'
      };
      if (val) {
        this.toggleLayout({ feild: key, val });
      } else {
        this.toggleLayout({ feild: key, val: false });
        this.toggleLayout({ feild: feildObj[key], val: true });
      }

      setTimeout(() => {
        if (e.val && e.key === 'layoutType') {
          this.init();
        }
      }, 0);
    },
    handleMenu(event) {
      this.$refs.contextMenuContainer.showMenu(event);
    },
    menuChecked({ option }) {
      const { commit } = option;
      if (['layoutType', 'showSider', 'showRight'].includes(commit)) {
        let val = !this.layout[commit];
        setTimeout(() => {
          if (val && commit === 'layoutType') {
            this.init();
          }
        }, 0);
        let feildObj = {
          showRight: 'showSider',
          showSider: 'showRight'
        };
        if (val) {
          this.toggleLayout({ feild: commit, val });
        } else {
          this.toggleLayout({ feild: commit, val: false });
          this.toggleLayout({ feild: feildObj[commit], val: true });
        }
      } else {
        if (commit) {
          this.rightClick({ key: commit });
        }
      }

    },

    toggleHasAnalyse() {
      this.rawRows.length > 1
        ? this.$message.warn("只能选中一个原料")
        : this.rawRows.length > 1 ? this.$message.warn("请选择一个原料") : this.toggleAnalyse();
    },
    toggleRoundingSet(){
      this.roundingSetVisible = !this.roundingSetVisible;
    },
    // 梯度分析
    toggleAnalyse() {
      this.analyseVisible = !this.analyseVisible;
    },

    getContainerHeight() {
      const boxHeight = this.$refs["editorContainer"]
        ? this.$refs["editorContainer"].offsetHeight
        : 900;
      const height = boxHeight - (this.layout.layoutType ? 140 : 160);
      this.editorContainerHeight = height;
      this.setState({ height });
    },

    // 配方页通知已读
    async refreshUpdate(callback) {
      // 配方最优解
      let updateData = {
        "formulaSolutionType": "0",
        "id": getRequest('id')
      };
      this.fetchPost({
        actions: this.updateFormulaFormulaSolutionType,
        data: updateData,
        showMessage: false
      });
      this.detail.formulaSolutionType = '0';
      callback && callback();
    },
    // 配方页通知已读
    async refreshUpdateById( id) {
      // 配方最优解
      let updateData = {
        "formulaSolutionType": "0",
        "id": id
      };
      this.fetchPost({
        actions: this.updateFormulaFormulaSolutionType,
        data: updateData,
        showMessage: false
      });
      this.detail.formulaSolutionType = '0';
    },

    async refreshPage() {
      clearInterval(this.refreshNoticeCompound);
      this.refreshNoticeCompound = null;
      await this.getDetail();
      await this.getDistributionDetail();
      // await this.getPrice();
      this.$refs["nutritionBlock"] && this.$refs["nutritionBlock"].getList();
      this.$refs["rawBlock"] && this.$refs["rawBlock"].getList();
    },

    //预估跳转
    changeEstimate({ key: optimizationType }) {
      if (optimizationType == 1) {
        // this.$router.push('/sat/estimated-record/add?id='+this.id)
        // let route =this.$router.resolve({path:'/sat/estimated-record/add?id='+this.id})
        // window.open(route.href,"_blank")
        this.toggleVisible('estimated');
      } else {
        // this.$router.push('/sat/estimated-record?id='+this.id)
        let route = this.$router.resolve({ path: '/sat/estimated-record?id=' + this.id });
        window.open(route.href, "_blank");
      }
    },

    async changeLinear({ key: optimizationType }) {
      if (this.$refs["rawBlock"].cacheData.length == 0) {
        this.$message.warning("请添加原料后优化");
        return;
      }
      let countMin = 0;
      let list = this.$refs["rawBlock"].cacheData;
      let list2 = this.$refs.nutritionBlock.cacheData;
      list && list.forEach(el => {
        if (el.isExtraProRaw !== '1' && el.isRawDelete !== '1') {
          countMin += Number(el.minValue || 0);
        }
      });
      let warnFlag = false;
      let gt = '>';
      let contentStr = '';
      let contentStr2 = '';
      let str = null;
      let str2 = null;
      str = list && list.map(el => {
        if ((el.minValue || el.minValue === 0) && (el.maxValue || el.maxValue === 0) && (Number(el.minValue) > Number(el.maxValue))) {
          warnFlag = true;
          contentStr += `配方原料:【${el.rawName}】的最小值 ${gt} 最大值；\r\n`;
          return <p>配方原料:【{el.rawName}】的最小值 {gt} 最大值</p>;
        }
      });
      str2 = list2 && list2.map(el => {
        if ((el.minValue || el.minValue === 0) && (el.maxValue || el.maxValue === 0) && (Number(el.minValue) > Number(el.maxValue))) {
          warnFlag = true;
          contentStr2 += `配方营养需要量:【${el.nutritionName}】的最小值 ${gt} 最大值；\r\n`;
          return <p>配方营养需要量:【{el.nutritionName}】的最小值 {gt} 最大值</p>;
        }
      });

      if (warnFlag) {
        this.$confirm({
          icon: () => <a-icon type="exclamation-circle" theme="twoTone" two-tone-color="#ffa600" />,
          title: '请注意',
          content: <div>{str}{str2}</div>,
          cancelText: '返回修改',
          okText: '复制信息',
          width: 500,
          // duration: 0,
          onOk: () => {
            let random = contentStr + contentStr2;
            const input = window.document.createElement('textarea');
            window.document.body.appendChild(input);
            input.innerHTML = random;
            // input.setAttribute('value',random);
            // input.select();
            input.setAttribute('code', 1);
            input.select();
            window.document.execCommand("Copy");

            var list = document.getElementsByTagName('textarea');
            var inputList = Array.prototype.slice.call(list);
            inputList.forEach((item) => {
              if (item.getAttribute('code')) document.body.removeChild(item);
            });
            this.$message.success('复制成功');
          },
          class: 'test',
        });
        return;
      }

      countMin = Number(countMin.toFixed(3));
      if (countMin > 100) {
        this.$warning({
          title: '配方无解',
          content: <div>
            <p>原料最小值总和为：<span style="color: #ff4d4f;">{countMin.toFixed(3)}</span> ，请调整原料约束!</p>
          </div>,
        });
        return;
      }
      const data = {
        formulaId: this.formulaId,
        optimizationType,
      };
      this.$track.sendTrack('clickEvent');
      const res = await this.fetchGet({
        actions: this.linearOptimizationByOptimization,
        data,
        showError: false,
        loading: "lineLoading",
      });

      this.initFormulaCache();
      if (res && res.success) {
        if (res.data.formulaSolutionType=='3') {
          this.$confirm({
            title: "优化成功，但存在以下有最小值却没有使用的原料",
            content: <span class='colorRed'>{res.data.msg}</span>,
            okText: '知道了',
            icon:'info-circle',
            cancelButtonProps: {
              style: { display: 'none' }
            },
            onOk: () => this.refreshPage()
          });
        } else {
          this.refreshPage();
          this.$message.success(res.data ? res.data.msg : '优化成功');
          console.log("优化完成")
        }
      } else {
        // this.$warning({
        //   title: "优化失败",
        //   content: '配方无解，请检查配方及营养指标约束。',
        //   cancelText: '知道了',
        // })
        this.$confirm({
          title: "优化失败",
          content: <span class='colorRed'>点击确定尝试获取次优解建议？</span>,
          okText: '确定',
          cancelText: '取消',
          onOk: () => this.openResult(data),
          onCancel: () => { }
        });
      }
    },
    openResult(data) {
      this.linearData = data || {};
      this.resultModalVisible = true;
    },
    getUserInfo() {
      const user = JSON.parse(window.localStorage.getItem("userInfo")) || {};
      const { userName, userId, email, code: userNo, userType, phoneNumber, clientId, } = user;
      return { userName, userId, email, userNo, userType, phoneNumber, clientId };
    },
    viewReport({ key }) {
      // let routeUrl = this.$router.resolve({
      //   path: `/nhf-compound-report?id=${this.formulaId}&formulaReportType=${formulaReportType}`,
      // });
      // window.open(routeUrl.href, "_blank");
      let url = [
        "/nhf-app/formulahis/exportFormulaExcelReport",
        "/nhf-app/formulahis/exportFormulaProExcelReport",
        "/nhf-app/formulahis/exportFormulaProductExcelReport",
        "/nhf-app/formulahis/exportProduceFormulaProExcelReport",
      ];
      let aliasFlag = window.localStorage.getItem('overseasFlag') == 1 ? 1 : 0;
      this.$fileDownload(url[key - 1], { formulaId: this.formulaId, aliasFlag }).catch(
        (e) => {
          e.message && this.$message.error(e.message);
        }
      );
      // this.$fileDownload('/nhf-app/formulahis/exportFormulaExcelReport',{formulaId: this.formulaId}).catch(e => {
      //   this.$message.error(e.message)
      // })
    },

    prcieChange(val) {
      if (val) this.detail.price = val;
    },

    async update(data) {
      this.toggleEditorVisible();
      await this.fetchPost({
        actions: this.formulaManageUpdate,
        loading: "updateLoading",
        data,
      });
      this.init();
    },

    toggleEditorVisible() {
      this.editorVisible = !this.editorVisible;
    },

    toggleFormulaBagVisible() {
      this.formulaBagVisible = !this.formulaBagVisible;
    },

    async handleFormulaBagRefresh() {
      // 刷新配方详情，更新 isStartBag 状态
      await this.getDetail()
    },

    openCreateRawBag() {
      if (!this.rawRows || this.rawRows.length < 2) {
        this.$message.warning('请至少选择2个原料才能创建组合包')
        return
      }
      if (this.rawRows.length > 3) {
        this.$message.warning('最多只能选择3个原料')
        return
      }
      this.createRawBagVisible = true
    },

    toggleCreateRawBag() {
      this.createRawBagVisible = !this.createRawBagVisible
    },

    async handleCreateRawBagSuccess() {
      // 创建成功后可以刷新页面或执行其他操作
      this.$message.success('原料组合包创建成功')
      // 刷新配方详情，更新 isStartRawBag 状态
      await this.getDetail()
      // 如果原料组合包管理抽屉是打开的，刷新其数据
      if (this.manageRawBagVisible && this.$refs.manageRawBag) {
        this.$refs.manageRawBag.loadRawBagList()
      }
      // 如果需要刷新原料列表，可以调用
      // this.refreshUpdate()
    },

    toggleManageRawBagVisible() {
      this.manageRawBagVisible = !this.manageRawBagVisible
    },

    async handleManageRawBagRefresh() {
      // 刷新配方原料数据
      await this.refreshPage()
    },

    togglePorductVisible() {
      this.productVisible = !this.productVisible;
    },

    tabChange(val) {
      this.tabSelect = val;
      this.setState({ rawRows: [], nutRows: [] });
      if (val == 1) this.$refs["rawBlock"] && this.$refs["rawBlock"].getList();
      if (val == 2) this.$refs["nutritionBlock"] && this.$refs["nutritionBlock"].getList();
    },

    async linearGood() {
      await this.fetchGet({
        actions: this.linearOptimization,
        loading: "goodLoading",
        data: {
          formulaId: this.formulaId,
        },
      });
      this.refreshPage();
    },

    toggleNeedVisible() {
      if (this.selectNutData.length > 1) {
        this.$message.info(`多个营养指标养分不能同时查看··`);
      } else {
        this.needVisible = !this.needVisible;
      }
    },

    toggleNutritenVisible() {
      if (this.rawSelect.length > 1) {
        this.$message.info(`多个原料不能同时查看`);
      } else {
        this.nutritenVisible = !this.nutritenVisible;
      }
    },

    toggleRawPanel() {
      this.rawVisible = !this.rawVisible;
    },

    toggleHidden(name) {
      if (this[name].length > 1) {
        this.$message.info(
          `多个${name == "rawRows" ? "原料" : "营养指标养分"}不能同时查看`
        );
        return;
      }
      const visible = name == "rawRows" ? "raw" : "nut";
      this.toggleVisible(visible);
    },

    async getDetail() {
      const res = await this.fetchGet({
        actions: this.formulaRawNhfDetail,
        // name:'detail',
        data: {
          formulaId: this.formulaId,
        },
      });
      if (res && res.data) {
        this.setState({ detail: res.data });
        if (
          this.deleteIds.includes(res.data.animalTypeCode) ||
          this.modelIds.includes(res.data.modelId)
        ) {
          this.updateAnimalVisible = true;
        }
        if (!res.data.typeClassify) {
          this.setState({ setClassVisible: true });
        }
      }
      await this.getPrice();
      // this.detailWidth()
    },
    async getPrice() {
      const productPrice = await this.fetchPost({
        actions: this.getProductPrice,
        showMessage: false,
        data: {
          formulaId: this.formulaId,
        },
      });
      this.productPrice = productPrice;
    },

    dragControllerDiv() {
      const resize = document.getElementsByClassName("resize");
      const left = document.getElementsByClassName("tableleft");
      const mid = document.getElementsByClassName("tableright");
      const box = document.getElementsByClassName("nhf-layout");
      for (let i = 0; i < resize.length; i++) {
        resize[i].onmousedown = (e) => {
          resize[i].style.background = "#e8e8e8";
          let startX = e.clientX;
          resize[i].left = resize[i].offsetLeft;
          document.onmousemove = (e) => {
            var endX = e.clientX;
            var moveLenght = resize[i].left + (endX - startX); // （endx-startx）=移动的距离。resize[i].left+移动的距离=左边区域最后的宽度
            var maxT = box[i].clientWidth - resize[i].offsetWidth; // 容器宽度 - 左边区域的宽度 = 右边区域的宽度
            if (moveLenght < 400) moveLenght = 400; // 左边区域的最小宽度为32px
            if (moveLenght > maxT - 400) moveLenght = maxT - 400; //右边区域最小宽度为150px
            resize[i].style.left = moveLenght; // 设置左侧区域的宽度
            for (let j = 0; j < left.length; j++) {
              // left[j].style.width = moveLenght + "px";
              // mid[j].style.width = box[i].clientWidth - moveLenght - 5 + "px";
              let leftWidth = parseInt((moveLenght / box[i].clientWidth) * 100);
              let rightWidth = parseInt(
                ((box[i].clientWidth - moveLenght - 5) / box[i].clientWidth) *
                100
              );
              left[j].style.width = leftWidth + "%";
              mid[j].style.width = rightWidth + "%";
            }
          };
          document.onmouseup = () => {
            resize[i].style.background = "#fff";
            document.onmousemove = null;
            document.onmouseup = null;
            resize[i].releaseCapture && resize[i].releaseCapture();
          };
          resize[i].setCapture && resize[i].setCapture();
          return false;
        };
      }
    },

    checkLiner() {
      return this.$refs["rawBlock"].list.records.some(
        (i) => i.percentage === "" || i.percentage === null
      );
    },

    saveCompound() {
      if (this.checkLiner()) {
        this.$message.warning("配方还未优化,无法更新配方版本");
        return;
      }
      this.updateVersionVisible = true;
    },

    async saveProductCompound() {
      if (!this.checkRaw()) {
        this.$warning({
          title: '产品生成失败',
          content: "配方中没有原料，无法生成产品！"
        });
        // this.$message.warning("配方中没有原料，无法生成产品！");
        return;
      }
      // if (this.checkLiner()) {
      //   this.$message.warning("配方还未优化,无法生成产品！");
      //   return;
      // }
      if (this.detail.formulaSolutionType !== '1') {
        this.$warning({
          title: '产品生成失败',
          content: "配方还未优化,无法生成产品！"
        });
        this.$message.warning("配方还未优化,无法生成产品！");
        return;
      }
      await this.saveProduce();
    },
    checkRaw() {
      return (
        this.$refs["rawBlock"].list.records &&
        this.$refs["rawBlock"].list.records.length > 0
      );
    },

    async saveFormulaProVersion() {
      await this.fetchPost({
        actions: this.saveProVersion,
        loading: "saveLoading",
        data: {
          formulaId: this.formulaId,
        },
      });
    },

    async formulaProduct() {
      await this.fetchPost({
        actions: this.saveFormulaProduct,
        loading: "saveLoading",
        data: {
          formulaId: this.formulaId,
          remark: this.remark,
        },
      });
    },

    async saveProduce() {
      const hide = this.$message.loading("产品生成中，请稍后...", 0);
      await this.fetchPost({
        actions: this.saveFormulaInfoPro,
        loading: "saveLoading",
        data: { formulaId: this.formulaId },
        modalMsg: '产品生成失败'
      });
      setTimeout(hide, 0);
    },
    saveRawFormula() {
      if (this.$refs["rawBlock"].list.records.length == 0) {
        this.$message.warning("请添加原料");
        return;
      }
      if (this.checkLiner()) {
        this.$message.warning("配方还未优化,无法保存为原料");
        return;
      }
      this.toggleVisible("saveRaw");
    },
    async saveFormula({ key }) {
      if (!this.detail.modelId) {
        this.$message.warning('请在配方基础信息中设置配方模型');
        return;
      }
      this.closeEbsAlert();
      const actions = [
        this.saveFormulaProVersion,
        this.saveCompound,
        this.saveProductCompound,
        this.saveRawFormula,
      ];
      // let flag = true
      if (key == 2 || key == 3) {
        if (this.detail.formulaSolutionType == 0) {
          // flag = false
          this.$message.warning('请先进行配方优化');
          return;
        }
      }
      // 更新版本和保存为原料不需要校验配方中是否包含失效原料
      if (key == 0 || key == 1 || key == 3) {
        actions[key]();
        return;
      }
      let checkProduct = await this.fetchGet({
        actions: this.checkCreatePro,
        loading: "saveLoading",
        data: { formulaId: this.formulaId },
      });
      let { success, msg, code } = checkProduct || {};
      if (!success) {
        if (code === 500) {
          await this.$confirm({
            title: '提示信息',
            content: '配方原料中包含失效原料:' + msg + '，是否仍要生成产品？',
            cancelText: '取消',
            okText: '确定',
            onOk: () => {
              console.log("now start save 2");
              actions[key]().then(() => {
                this.refreshPage();
              });
            },
            onCancel: () => {

            }
          });
        } else {
          //flag = false
          this.$message.warning(msg);
        }
      } else {
        // if (!flag) return
        console.log("now start save 1");
        await actions[key]().then(() => {
          this.refreshPage();
        });
      }
    },
    closeUpdateAnimal(type) {
      if (type) {
        this.contrastTargetAddDiff();
        this.initSize();
        this.getContainerHeight();
        this.init();
      }
      this.updateAnimalVisible = false;
    },

    openRMPResult() {
      this.RMPVisible = true;
    },
    closeRMPModal() {
      this.RMPVisible = false;
    }
  },
};
</script>
<style lang="scss" scoped>
.menu {
  padding: 5px 15px;

  ::v-deep .ant-radio-wrapper {
    display: block;
    margin: 10px 0;
  }
}

.icon-bar ::v-deep .anticon {
  font-size: 16px !important;
}

::v-deep .ant-tabs-bar {
  margin: 0 10px;
}
</style>
<style lang="scss">
.formulaNameStyle {
  max-width: 350px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.disabledMenu {
  background-color: #f5f5f5;
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.disabledMenu:hover {
  background-color: #f5f5f5 !important;
  color: rgba(0, 0, 0, 0.25) !important;
}

.ant-tooltip-inner {
  font-size: 12px;
}

.vue-simple-context-menu {
  box-shadow: 0 4px 12px rgba($color: #000000, $alpha: 0.3);
  background: #fff;

  &--active {
    background: #fff;
    color: #444;
  }

  &__item {
    width: 180px;
    font-size: 13px;

    span {
      width: 180px;
      display: flex;
      justify-content: space-between;
      padding: 3px 0;

      b {
        font-weight: normal;
      }
    }

    i {
      width: 13px;
      height: 7px;
      border: 2px solid #1890ff;
      border-top: none;
      border-right: none;
      transform: rotate(-45deg) scale(0.9) translateY(4px);
    }

    &:hover {
      background-color: lighten(#1890ff, 44%);
      color: #1890ff;
    }
  }

  &__divider {
    height: 1px;
    background-color: #e8e8e8;
  }
}

.tableleft,
.tableright,
.resize {
  float: left;
}

.nhf-editor {
  overflow: hidden;

  &-container {
    max-width: 1400px;
    margin: 0 auto;
  }
}

.nhf-app {
  overflow: hidden;
  height: 100vh;
  max-height: 100vh;

  h1,
  h2,
  h3,
  h4 {
    margin: 0;
    padding: 0;
  }
}

.nhf-layout h2 {
  font-size: 14px;
  padding: 15px !important;
}

.nhf-header {
  padding: 10px 20px 0;
}

.nhf-title {
  font-size: 14px;
  font-weight: 800;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.nhf-logo {
  // width: 80px;
  height: 23px;
  margin-right: 8px;
}

.nhf-title span {
  color: #1890ff;
  padding: 0 4px;
  border-left: 4px solid #1890ff;
  line-height: 12px;
}

.nhf-header-main {
  padding: 8px 15px 4px;
  border-bottom: 1px solid #e8e8e8;
}

.nhf-header-main h3 {
  font-size: 18px;
  color: #444;
}

.ant-table-thead>tr>th,
.ant-table-tbody>tr>td {
  position: relative !important;
}

.ant-table-row-cell-break-word {
  position: relative !important;
}

.nhf-container {
  border-radius: 5px;
  background: #fff;
  min-width: 800px;
  margin: 10px 20px 15px;
  height: calc(100vh - 70px);
  border-radius: 5px;
  background: #fff;
}

.editor-container {
  flex: 1;
}

.col {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  padding: 0 10px;
  font-size: 12px;

  h2 {
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 18px;
    font-weight: 900;
    color: #444;

    span {
      &.red {
        color: red;
      }

      &.green {
        color: green;
      }

      b {
        color: #444;
        margin: 0 4px;
      }
    }
  }
}

.ant-layout-content {
  min-height: 100vh;
}

.appBox {
  height: inherit !important;
}

.resize {
  cursor: col-resize;
  width: 4px;
  height: calc(100vh - 175px);
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  &:hover {
    color: #444444;
  }

  &:after {
    left: -2px;
    right: -2px;
    border: 1px solid #888;
    border-top: none;
    border-bottom: none;
    height: 22px;
    content: "";
    margin-top: -11px;
    position: absolute;
    top: 50%;
  }

  &:before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 50%;
    background-color: #e8e8e8;
    width: 1px;
  }
}
</style>
